import React from "react";
import "../styles/NumberCircle.css";

export default props => {
  return <span className="circle">{props.children}</span>;
};



// WEBPACK FOOTER //
// ./src/elements/NumberCircle.js